// extracted by mini-css-extract-plugin
export default {"resultsCards":"SearchResultCardList_resultsCards__UsEk+"};